import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  search: "",
  sort: { sort: "price", order: "desc" },
  filterCategory: "All",
};

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    searchProduct: (state, action) => {
      state.search = action.payload;
    },

    clearSearch: (state) => {
      state.search = "";
    },

    // setFilterCategory: (state, action) => {
    //   state.filterCategory = action.payload;
    // },

    filterProduct: (state, action) => {
      state.filterCategory = action.payload;
    },
  },
});

export const { searchProduct, clearSearch, filterProduct } =
  searchSlice.actions;

export default searchSlice.reducer;
